import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Select } from 'antd';
import { AuthWrapper } from '../../style';
import { Checkbox } from '../../../../../../components/checkbox/checkbox';
import Heading from '../../../../../../components/heading/heading';
import { useDispatch, useSelector } from 'react-redux';
import { submitMetadata } from '../../../../../../redux/authentication/actionCreator';
import ReactGA from 'react-ga';
import './BankDetails.css';
// import { bankList } from "../utils";
import api from '../../../../../../redux/authentication/api';

function BankDetails() {
  const { Option } = Select;
  const [state, setState] = useState({
    values: null,
    checked: null,
  });
  const [bankList, setBankList] = useState(null);
  const dispatch = useDispatch();
  const isLoading = useSelector(state => state.auth.loading);
  const dataForm = useSelector(state => state.auth.dataForm);

  useEffect(() => {
    const getBank = async () => {
      if (!bankList) {
        let data = await api.get('/signup/prerequisites');
        setBankList(data.data.banks);
      }
    };
    getBank();
  }, [bankList]);

  const handleSubmit = values => {
    setState({ ...state, values });
    ReactGA.event({ category: 'Kongsi Klub Signup', action: 'Enter Bank Details' });

    let param = {
      preferredName: dataForm.preferredName,
      email: dataForm.email,
      nric: dataForm.nric,
      password: dataForm.password,
      bank: {
        bankId: values.bankID,
        accountNumber: values.bankAccountNumber,
      },
      preferredLanguage: 'ms',
      customerId: dataForm.customerId,
    };
    dispatch(submitMetadata(param, dataForm.kycToken));
  };

  const onChange = value => {
    // console.log(`selected ${value}`);
  };

  const onChange2 = checked => {
    setState({ ...state, checked });
  };
  return (
    <AuthWrapper>
      <div className="auth-contents">
        <Form name="register" onFinish={handleSubmit} layout="vertical">
          <Heading as="h5">Informasi Bank</Heading>
          <p>Kami akan menghantar Kongsi-Kash (Ganjaran) anda melalui akaun bank ini.</p>
          <Form.Item name="bankID" label="Nama Bank" rules={[{ required: true, message: 'Nama bank diperlukan' }]}>
            <Select placeholder="Pilih Bank Anda" onChange={onChange}>
              <Option value="" disabled>
                NAMA BANK
              </Option>
              {bankList &&
                bankList.map((item, i) => (
                  <Option style={{ backgroundColor: 'white' }} key={i} value={item.bankId}>
                    {item.name}
                  </Option>
                ))}
            </Select>
          </Form.Item>

          <Form.Item
            name="bankAccountNumber"
            rules={[
              { message: 'Nombor akaun bank diperlukan', required: true },
              { pattern: /^[0-9]{5,20}$/, message: 'Sila isikan nombor akaun bank yang sah' },
            ]}
            label="Nombor Akaun Bank"
          >
            <Input type="number" placeholder="8575848392934484" />
          </Form.Item>
          <div className="auth-form-action">
            <Checkbox onChange={onChange2}>
              <div className="checkbox-field">
                Saya dengan ini mengesahkan bahawa segala maklumat yang saya berikan adalah tepat, benar dan lengkap dan
                semua butiran perbankan yang diberikan adalah sah dan dimiliki oleh saya.
              </div>
            </Checkbox>
          </div>
          <Form.Item>
            <Button
              className="btn-create"
              htmlType="submit"
              type="primary"
              size="large"
              disabled={!state.checked || isLoading}
            >
              {isLoading ? 'Loading..' : 'SAHKAN'}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </AuthWrapper>
  );
}

export default BankDetails;
